import { persistStore } from "redux-persist";
import { useStore } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from "./reducer";
import { baseApi } from "../api/base";
import { blogApi } from "../../components/apis/blogApi";
import { metaBuilderApi } from "../../components/apis/metaBuilderApi";
import popupReducer from "../popupSlice";

export const store = configureStore({
  reducer: {
    ...rootReducer,
    popup: popupReducer,
    [baseApi.reducerPath]: baseApi.reducer,
    [blogApi.reducerPath]: blogApi.reducer,
    [metaBuilderApi.reducerPath]: metaBuilderApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(baseApi.middleware)
      .concat(blogApi.middleware)
      .concat(metaBuilderApi.middleware),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useMyStore = (): typeof store => useStore();
